'use strict';

import BamTeamData from 'bam-team-data';
const cloneDeep = BamTeamData.getHelpers().cloneDeep;

/**
 * "Private" static functions used by BamGameUtils and subclasses.  Other consumers should not call these
 * methods.
 * @private
 */
class Helpers {

    /**
     * Validates options passed to the BamGameUtils constructor, throws an error if invalid.
     * @param candidateOptions The options object passed to the constructor
     * @param supportedOptionSpecs SUPPORTED_OPTION_SPECS
     * @throws Error if options are not valid
     */
    static validateOptions(candidateOptions, supportedOptionSpecs) {
        let errMsg = null;
        let options = (!candidateOptions ? {} : candidateOptions);

        // Options must be an object:
        if (typeof options !== 'object' || Array.isArray(options)) {
            errMsg = 'is not an object.';
        }

        // Each user-specified option must conform to its spec:
        if (!errMsg) {
            let optionKeys = Object.keys(options);
            let optionSpec;
            let optionValue;
            let optionValueType;
            let optionKey;
            for (let i = 0, ln = optionKeys.length; i < ln; i++) {
                optionKey = optionKeys[i];
                optionSpec = supportedOptionSpecs[optionKey];
                if (optionSpec === undefined) {
                    errMsg = 'contains unsupported option: ' + optionKey;
                    break;
                }
                optionValue = options[optionKey];
                optionValueType = (Array.isArray(optionValue) ? 'array' : typeof optionValue);
                if (optionValue !== null) {
                    if (optionValueType !== optionSpec.expectedType) {
                        errMsg = 'contains option with unexpected value type for "' + optionKey +
                            '" (expected: ' + optionSpec.expectedType + '; found: ' + optionValueType + ')';
                        break;
                    }
                }
            }
        }

        // Required options must be present:
        let specKeys = Object.keys(supportedOptionSpecs);
        let specKey;
        for (let i = 0, ln = specKeys.length; i < ln; i++) {
            specKey = specKeys[i];
            if (!supportedOptionSpecs[specKey].required) {
                continue;
            }
            if (options[specKey] === undefined) {
                errMsg = 'did not contain a required option: ' + specKey;
                break;
            }
        }

        if (errMsg) {
            throw new Error('The options arg you passed ' + errMsg);
        }
    }

    /**
     * Return an object whose properties are option keys and values are default values for those options
     * @param supportedOptionSpecs
     * @return {{}}
     */
    static getDefaultOptions(supportedOptionSpecs) {
        let defaultOptions = {};
        let optionKeys = Object.keys(supportedOptionSpecs);
        let key;
        for (let i = 0, ln = optionKeys.length; i < ln; i++) {
            key = optionKeys[i];
            defaultOptions[key] = supportedOptionSpecs[key].defaultValue;
        }
        return defaultOptions;
    }

    /**
     * Returns the value of a call to the lodash cloneDeep method, which returns a deep copy of the passed value.
     * @param arg
     */
    static cloneDeep(arg) {
        return cloneDeep(arg);
    }

    /**
     * Methods should call this if the base class doesn't implement the method, relying on subclasses to do so.
     * @param methodName The name of the unimplemented method, for the Error message
     * @throws Error when called.
     */
    static throwNotImplementedError(methodName) {
        throw new Error(methodName + '() is not implemented in the BamGameUtils, and the subclass has not provided' +
            'an implementation either.');
    }

    /**
     * Passed a browser window or a controller "req" object, returns the dictionary data
     * @param ctx
     */
    static getDictFromContext(ctx) {
        // the eventual logic will look something like this, but these elements are not in place yet, so hard-coding
        // the dictionary below for now:

        if (ctx.i18n_dictionary) {
            // window:
            return ctx.i18n_dictionary;
        } else if (ctx.configFinder && ctx.i18n) {
            // controller req:
            return ctx.i18n;
        } else {
            //throw new Error('ctx (' + ctx + ') is not a window or req object.');
            // dict not available yet, so:
            return {
                recap: 'Recap',
                watch: 'Watch',
                gameday: 'Gameday',
                preview: 'Preview',
                wrap: 'Wrap',
                boxscore: 'Boxscore',
                box: 'Box',
                tickets: 'Tickets',
                buysell: 'Buy/Sell',
                video: 'Video',
                mlbtv: 'MLB.tv'
            };

        }
    }

}

export default Helpers;
